module.exports = __webpack_public_path__ + "static/media/gameboy.a175c125.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/illus/gameboy.svg
// module id = 150
// module chunks = 0